<div class="pnyc-notification-bell">

    <div class="pnyc-notification-bell-header-wrap">
        <div class="pnyc-notification-bell-header">

            <div class="pnyc-notification-bell-header-top">
                <div class="pnyc-notification-bell-header-title pnyc-typography-title">{{ 'NOTIFICATION_BELL.WHATS_NEW' |
                    translate }}</div>

                @if (hasCloseButton()) {
                    <pnyc-button class="pnyc-notification-bell-header-close" [iconName]="'close'"
                        [title]="'NOTIFICATION_BELL.CLOSE' | translate" (clicked)="closeEvent.emit()">
                    </pnyc-button>
                }
            </div>

            <div class="pnyc-notification-bell-header-filters">
                <pnyc-slide-toggle class="pnyc-notification-bell-header-toggle"
                    [firstText]="'NOTIFICATION_BELL.UNREAD_ONLY' | translate" [checked]="isUnreadOnly()"
                    (changed)="toggleUnread()">
                </pnyc-slide-toggle>

                @if(hasMarkAllAsRead()) {
                    <div class="pnyc-notification-bell-header-mark" (click)="markAllAsRead()">{{
                    'NOTIFICATION_BELL.MARK_ALL_READ'
                    | translate }}</div>
                }
            </div>

        </div>

        <pnyc-tabs class="pnyc-notification-bell-tabs" [tabItems]="tabs" [value]="selectedTab()"
            (changed)="onTabChange($event.value)">
        </pnyc-tabs>
    </div>

    @if (isLoading()) {
        <div class="pnyc-notification-bell-skeleton">
            @for (item of [1,2,3]; track item) {
                <div class="pnyc-notification-bell-skeleton-item">
                    <div class="pnyc-notification-bell-skeleton-avatar"></div>
                    <div class="pnyc-notification-bell-skeleton-content">
                        <div class="pnyc-notification-bell-skeleton-line pnyc-notification-bell-skeleton-line--title">
                        </div>
                        <div
                            class="pnyc-notification-bell-skeleton-line pnyc-notification-bell-skeleton-line--subtitle">
                        </div>
                        <div class="pnyc-notification-bell-skeleton-line pnyc-notification-bell-skeleton-line--date">
                        </div>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div class="pnyc-notification-bell-body">

            <div class="pnyc-notification-bell-list">

                @for(group of notificationGroups(); track group) {
                    <div class="pnyc-notification-bell-section">

                        <div class="pnyc-notification-bell-section-title">{{ GROUP_NAMES[group.type] | translate }}
                        </div>

                        @for(notification of group.items; track notification) {
                            <notification-item class="pnyc-notification-bell-item" [notification]="notification"
                                (markAsRead)="markAsRead($event.id, $event.isGroup, $event.isRedirect)"
                                (toggleCollapsed)="toggleCollapsed(notification.id)" (redirect)="onRedirect($event)">
                            </notification-item>
                        }

                    </div>
                } @empty {
                    <div class="pnyc-notification-bell-empty pnyc-empty-mask">

                        <div class="pnyc-empty-mask-content">

                            <div class="pnyc-empty-mask-icon-wrap">
                                <pnyc-icon class="pnyc-empty-mask-icon" [iconName]="'bell-off'">
                                </pnyc-icon>
                            </div>

                            <div class="pnyc-empty-mask-title">
                                {{ 'NOTIFICATION_BELL.NO_NOTIFICATIONS' | translate }}
                            </div>

                            <div class="pnyc-empty-mask-subtitle">
                                {{ 'NOTIFICATION_BELL.YOU_WILL_BE_NOTIFIED' | translate }}
                            </div>

                        </div>

                    </div>
                }

            </div>

        </div>
    }

</div>